export default __webpack_public_path__ + "static/media/bkg--team-1.9f06696e.jpg";